import React from "react";

// Context
import {
  ACTIONS,
  useModalHistory,
} from "../../../context/ModalHistoryProvider";

// Components
import { ListPriceDealsButton } from "../../Controls/ListPriceDealsButton";
import { SchemeDealsButton } from "../../Controls/SchemeDealsButton";
import QueueStyle from "../../Styled/Queue.style";
import ListPriceDealsUploadModal from "./ListPriceDealsUploadModal";
import Modal from "../../Modal/Modal";
import SchemeDealsUploadModal from "./SchemeDealsUploadModal";

export default function ExcelDealsUploadModal() {
  const [, dispatchModalHistory] = useModalHistory();

  const pushEnd = (modal) =>
    dispatchModalHistory({ type: ACTIONS.PUSH_END, payload: { value: modal } });

  return (
    <Modal title="Choose a deal type to upload">
      <QueueStyle>
        <SchemeDealsButton
          onClick={() => pushEnd(<SchemeDealsUploadModal />)}
        />
        <ListPriceDealsButton
          onClick={() => pushEnd(<ListPriceDealsUploadModal />)}
        />
      </QueueStyle>
    </Modal>
  );
}
